import { render, staticRenderFns } from "./LandingImageText.vue?vue&type=template&id=32643379&name=landing-image-text&"
import script from "./LandingImageText.vue?vue&type=script&lang=js&"
export * from "./LandingImageText.vue?vue&type=script&lang=js&"
import style0 from "./LandingImageText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports